import React from 'react';
import LoginForm from 'src/components/UI/forms/Login';

const Login = () => <LoginForm />;

export default Login;
